import { render, staticRenderFns } from "./my-request-link-from-home.vue?vue&type=template&id=0a814e64&"
import script from "./my-request-link-from-home.vue?vue&type=script&lang=js&"
export * from "./my-request-link-from-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports